/**
 * O que a Adocao e Engajamento pede ao servidor, e o que volta de la.
 *
 * Mora aqui, e nao em `domain`, porque nenhuma outra tela le estes tipos - e o
 * mesmo criterio das tabelas de codigo: o payload pertence a quem o consome. Quem
 * fala com o servidor e `user-base.api.ts`, ao lado.
 */
import { periodRange } from '../../../../components/period';
/**
 * Os atalhos de periodo que esta tela oferece.
 *
 * Sao um SUBCONJUNTO do vocabulario de `components/period` - quais existem e
 * decisao de cada tela, como cada um se calcula e decisao de la. `custom` e o
 * intervalo digitado.
 */
export const USER_BASE_SHORTCUTS = ['30d', '90d', '12m', 'year', 'custom'];
/**
 * A granularidade que cada atalho IMPLICA.
 *
 * Fica aqui, e nao no `components/period`, porque granularidade nao e periodo: e
 * como esta tela AGREGA o que buscou, e so ela tem esse eixo. O que o seletor
 * compartilhado sabe e o intervalo.
 *
 * A implicacao e so um ponto de partida - quem quiser ver doze meses dia a dia troca
 * no botao, e ai o valor vai para o endereco por divergir do implicado.
 */
export const IMPLIED_GRANULARITY = {
    '30d': 'DAY',
    '90d': 'DAY',
    '12m': 'MONTH',
    year: 'MONTH'
};
/**
 * O intervalo de cada atalho. `custom` nao tem: e o que o leitor digitou.
 *
 * A CONTA mora no `components/period` - esta funcao so a chama e veste o resultado
 * com a granularidade implicada, que e a parte desta tela.
 */
export function intervalOf(preset) {
    if (preset === 'custom') {
        return null;
    }
    const { from, to } = periodRange(preset);
    return { startDate: from, endDate: to, granularity: IMPLIED_GRANULARITY[preset] ?? 'DAY' };
}
//# sourceMappingURL=user-base.types.js.map